import React from "react";
import styled from "styled-components";
import useLeagueLinks from "../../hooks/useLeagueLinks";
import useTeamLinks from "../../hooks/useTeamLinks";
import NavBotLinks from "./NavBotLinks";

const StyledNavBotContainerDiv = styled.div`
  background: ${(props) => props.theme.colors.navBgSecond()};
  color: ${(props) => props.theme.colors.navColorSecond()};
  box-shadow: 0 0 20px ${(props) => props.theme.colors.boxShadow};
  z-index: 200;
`;

const StyledNavBotDiv = styled.div`
  max-width: ${(props) => props.theme.sizes.pageWidth};
  margin: 0 auto;
  text-transform: uppercase;
`;

const StyledNavBotUl = styled.ul`
  height: 2rem;
  justify-content: space-between;
`;

export default function NavBot() {
  const leagueLinks = useLeagueLinks();
  const teamLinks = useTeamLinks();

  return (
    <StyledNavBotContainerDiv>
      <StyledNavBotDiv>
        <StyledNavBotUl className={"flex"}>
          <li>
            <NavBotLinks links={leagueLinks} />
          </li>
          <li>
            <NavBotLinks links={teamLinks} />
          </li>
        </StyledNavBotUl>
      </StyledNavBotDiv>
    </StyledNavBotContainerDiv>
  );
}
